import * as index from "./sites/index.js";
import "../lib/base.js";
import { mergeRight } from "../lib/merge.js";
import { createSiteConfig } from "../lib/utils.js";
import { globalConfig } from "./global-config.js";
function getPrimaryConfig() {
  const siteConfig = createSiteConfig(index);
  return globalConfig.chain((global) => siteConfig.chain((site) => mergeRight(global, site)));
}
export {
  getPrimaryConfig
};
//# sourceMappingURL=config.js.map
